import React from "react";
import { IoChatboxEllipses } from "react-icons/io5";
import "./Chatbot.css";
function ChatMessage({ chat }) {
  return (
    !chat.hideInChat && (
      <div
        className={`message ${chat.role === "model" ? "bot" : "user"}-message ${
          chat.isError ? "error" : ""
        }`}
      >
        {chat.role === "model" && <IoChatboxEllipses className="chat-icon" />}
        <p className="message-text">{chat.text}</p>
      </div>
    )
  );
}

export default ChatMessage;
